import React from "react";
import {
  AdjustmentsVerticalIcon,
  ChatBubbleBottomCenterTextIcon,
  RectangleStackIcon,
  DocumentTextIcon,
  MusicalNoteIcon,
} from "@heroicons/react/20/solid";
import { Button, Modal } from "player-components";
import "./style.css";

const SongDetailsModal = ({
  song,
  lyrics,
  lyricsStatus,
  restricted,
  isOpen,
  onClose,
  onOpen,
  onAddToSetlist,
  onLyricsPreview,
  onOpenSheetMusic,
  onSubscribe,
  subscribeConfig,
  autoPlayPreview = false
}) => {
  const renderSongPreview = () => {
    return (
      <div className="bg-white  overflow-y-scroll sm:rounded-lg">
        <div className="pb-4 ">
          <h3 className="text-lg leading-6 font-medium text-gray-900 flex">
            <MusicalNoteIcon className="w-6 h-6 mr-2" />
            {song.mix}
          </h3>
          <p className="mt-1 max-w-2xl text-sm text-gray-500">{song.artist}</p>
        </div>
        <div className="sm:p-0">
          <dl className="sm:divide-y">
            <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 ">
              <dd
                className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2"
                dangerouslySetInnerHTML={{ __html: song.desc }}
              ></dd>
            </div>

            <div className="sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4">
              <span className="flex space-x-2 text-xs text-secondary-50 items-center">
                <span className="text-secondary-900 dark:text-secondary-300">
                  Genre:
                </span>
                <span className="bg-primaryAlt rounded px-1 py-0.5">
                  {song.genre}
                </span>
                <span className="text-secondary-900 dark:text-secondary-300">
                  Year:{" "}
                </span>
                <span className="bg-primaryAlt rounded px-1 py-0.5">
                  {song.decade}
                </span>
                <span className="text-secondary-900 dark:text-secondary-300">
                  Key:
                </span>
                <span className="bg-primaryAlt rounded px-1 py-0.5">
                  {song.key}
                </span>
                {song.level && (
                  <>
                    <span>Level:</span>
                    <span className="bg-primaryAlt rounded px-1 py-0.5">
                      {song.level}
                    </span>
                  </>
                )}
              </span>
            </div>
            <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4">
              <dt className="text-sm font-medium text-gray-500">Preview</dt>
              <dd className="mt-4 text-sm text-gray-900 sm:col-span-2">
                <audio
                  controlsList="nodownload"
                  className="audioPreview"
                  autoPlay={autoPlayPreview}
                  controls
                  src={song.sampleUrl}
                />
              </dd>
            </div>

            <div className="pt-4 flex items-center">
              {!restricted && (
                <>
                  <span className="relative z-0 grow inline-flex shadow-sm rounded-md ">
                    
                    <button
                      onClick={() => onOpen(song.songId)}
                      type="button"
                      className="-ml-px relative inline-flex flex-col grow items-center px-4 py-2 border rounded-l-md border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                    >
                      <AdjustmentsVerticalIcon className="h-6 w-6" />
                      <span>Open song</span>
                    </button>
                    <button
                      onClick={onAddToSetlist}
                      type="button"
                      className="-ml-px relative inline-flex flex-col grow items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                    >
                      <RectangleStackIcon className="h-6 w-6" />
                      <span>Add to setlist</span>
                    </button>
                    <button
                      onClick={onLyricsPreview}
                      type="button"
                      className="relative inline-flex flex-col grow items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                    >
                      <ChatBubbleBottomCenterTextIcon className="h-6 w-6" />
                      <span>View lyrics</span>
                    </button>
                    <button
                      disabled={!song.sheetUrl? true: false}
                      onClick={()=>onOpenSheetMusic(song.sheetUrl)}
                      type="button"
                      className={`${song.sheetUrl ? '' : 'opacity-50'} -ml-px relative inline-flex flex-col grow items-center px-4 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500`}
                    >
                      <DocumentTextIcon className="h-6 w-6" />
                      <span>Sheet music</span>
                    </button>

                    
                  </span>
                </>
              )}
              {restricted && (
                <div className="flex flex-col justify-center">
                  <p className="mb-4">{subscribeConfig.text}</p>
                  <Button onClick={onSubscribe}>
                    {subscribeConfig.buttonLabel}
                  </Button>
                </div>
              )}
            </div>
          </dl>
        </div>
      </div>
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      content={
        <div style={{ minHeight: 300 }}>{song && renderSongPreview()}</div>
      }
      closeLabel={"Close"}
      onClose={onClose}
    />
  );
};

export default SongDetailsModal;
